export default __webpack_public_path__ + "static/media/SubWebWarnings.85ba21a6.png";